import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AlertType } from '../../../../../alerts/models';

@Component({
    selector: 'bs-linear-bet-builder-notification',
    template: '<bs-alert [message]="betBuilderNotification" [type]="type" />',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LinearBetBuilderNotificationComponent {
    @Input() betBuilderNotification: string;

    readonly type = AlertType.Information;
}
